<template>
  <b-card-actions title="الفعاليات الحالية">
    <b-card-body>
      <div class="row">
        <div class="col-4 calendar-area">
          <b-row class="text-center">
            <!-- calendar -->
            <b-calendar
              style="min-width: 250px"
              v-model="value"
              locale="ar-EG"
              v-bind="ar"
              start-weekday="6"
              @context="onContext"
            />
          </b-row>
        </div>
        <div
          class="col-8 scrollArea tabs-area"
          style="height: 300px; overflow: auto"
        >
          <b-tabs content-class="pt-1" fill>
            <b-tab title="المحاضرات" active>
              <b-card-text>
                <app-timeline v-if="!load">
                  <app-timeline-item
                    v-for="content in contents"
                    :key="content.id"
                    :icon="getType(content.type).icon"
                    :variant="getColor()"
                  >
                    <div
                      class="
                        d-flex
                        flex-sm-row flex-column flex-wrap
                        justify-content-between
                        mb-1 mb-sm-0
                      "
                    >
                      <b-link @click="goToContent(content)"
                        ><h6>{{ content.name }}</h6></b-link
                      >
                      <small class="text-muted">{{ content.start_in }}</small>
                    </div>
                    <small>{{ getType(content.type).title }}</small>
                  </app-timeline-item>
                </app-timeline>
                <b-spinner v-else type="grow" label="Loading..."  class="loading" />
              </b-card-text>
            </b-tab>
            <b-tab
              @click="newItem = {}"
              :title="$t('online_session.online_class')"
            >
              <b-card-text>
                <app-timeline v-if="!load">
                  <app-timeline-item
                    v-for="content in selectType('direct_lectures')"
                    :key="content.id"
                    :icon="getType(content.type).icon"
                    :variant="getColor()"
                  >
                    <div
                      class="
                        d-flex
                        flex-sm-row flex-column flex-wrap
                        justify-content-between
                        mb-1 mb-sm-0
                      "
                    >
                      <b-link @click="goToContent(content)"
                        ><h6>{{ content.name }}</h6></b-link
                      >
                      <small class="text-muted">{{ content.start_in }}</small>
                    </div>
                    <small>{{ getType(content.type).title }}</small>
                  </app-timeline-item>
                </app-timeline>
                <b-spinner v-else type="grow" label="Loading..."  class="loading" />
              </b-card-text>
            </b-tab>
            <b-tab @click="newItem = {}" title="الاختبارات ">
              <b-card-text>
                <app-timeline v-if="!load">
                  <app-timeline-item
                    v-for="content in selectType('exam')"
                    :key="content.id"
                    :icon="getType(content.type).icon"
                    :variant="getColor()"
                  >
                    <div
                      class="
                        d-flex
                        flex-sm-row flex-column flex-wrap
                        justify-content-between
                        mb-1 mb-sm-0
                      "
                    >
                      <b-link @click="goToContent(content)"
                        ><h6>{{ content.name }}</h6></b-link
                      >
                      <small class="text-muted">{{ content.start_in }}</small>
                    </div>
                    <small>{{ getType(content.type).title }}</small>
                  </app-timeline-item>
                </app-timeline>
                <b-spinner v-else type="grow" label="Loading..."  class="loading"
              /></b-card-text>
            </b-tab>
            <b-tab @click="newItem = {}" title="التدريبات">
              <b-card-text>
                <app-timeline v-if="!load">
                  <app-timeline-item
                    v-for="content in selectType('assessments')"
                    :key="content.id"
                    :icon="getType(content.type).icon"
                    :variant="getColor()"
                  >
                    <div
                      class="
                        d-flex
                        flex-sm-row flex-column flex-wrap
                        justify-content-between
                        mb-1 mb-sm-0
                      "
                    >
                      <b-link @click="goToContent(content)"
                        ><h6>{{ content.name }}</h6></b-link
                      >
                      <small class="text-muted">{{ content.start_in }}</small>
                    </div>
                    <small>{{ getType(content.type).title }}</small>
                  </app-timeline-item>
                </app-timeline>
                <b-spinner v-else type="grow" label="Loading..."  class="loading" />
              </b-card-text>
            </b-tab>
          </b-tabs>

          <!-- <b-spinner v-else type="grow" label="Loading..."  class="loading" /> -->
        </div>
      </div>
    </b-card-body>
  </b-card-actions>
</template>

<script>
import { BRow, BCol, BCalendar } from "bootstrap-vue";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import EduCoursesController from "@/Controllers/EduCoursesController";
import Auth from "@/Apis/Auth";

import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
export default {
  components: {
    BRow,
    BCol,
    BCalendar,
    Prism,
    AppTimeline,
    AppTimelineItem,
    BCardActions,
  },
  data: () => ({
    value: "",
    context: null,
    ar: {
      weekdayHeaderFormat: "narrow",
      labelPrevDecade: "العقد السابق",
      labelPrevYear: "العام السابق",
      labelPrevMonth: "الشهر السابق",
      labelCurrentMonth: "الشهر الحالي",
      labelNextMonth: "الشهر المقبل",
      labelNextYear: "العام المقبل",
      labelNextDecade: "العقد القادم",
      labelToday: "اليوم",
      labelSelected: "التاريخ المحدد",
      labelNoDateSelected: "لم يتم اختيار تاريخ",
      labelCalendar: "التقويم",
      labelNav: "الملاحة التقويم",
      labelHelp: "استخدم مفاتيح المؤشر للتنقل في التواريخ",
    },

    load: false,
    contents: [],
  }),
  async created() {
    this.types = new EduCoursesController().Types();
  },
  methods: {
    onContext(ctx) {
      this.context = ctx;
      this.getContentsNow();

      //selectedYMD
    },
    goToContent(item) {
      console.log(item);
      localStorage.setItem("content", JSON.stringify(item));
      this.$router.push({ name: "Courses" });
    },
    getType(type) {
      return new EduCoursesController().GetType(type);
    },
    selectType(type) {
      return this.contents.filter((a) => a.type == type);
    },
    async getContentsNow() {
      let id = localStorage.getItem("eduProgram");
      let room = Auth.ROOM.find((a) => a.edu_program_id == id);
      this.load = true;
      const res = await new EduCoursesController().getContentsNow({
        eduProgramId: id,
        room_id: room.id,
        date: this.value,
      });
      this.load = false;
      this.contents = res.data.map((item) => ({
        id: item.id,
        name: item.get_edu_content.name,
        type: item.get_edu_content.type,
        description: item.get_edu_content.description,
        start_in: Auth.GetDateTimeZone(item.start_in),
        end_in: Auth.GetDateTimeZone(item.end_in),
        file: item.get_edu_content.file,
        data: item,
        exam_id: item.get_edu_content.exam_id,
        online_class_ids: item.get_edu_content.online_class_ids,
        h5p: item.get_edu_content.h5p_content_id,
      }));
    },
    getColor() {
      let color = [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "info",
      ];
      return color[Math.floor(Math.random() * 5)];
    },
  },
};
</script>
